import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { AuthService } from './auth/services/auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenInterceptorService } from './auth/services/token-interceptor.service';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { LoaderInterceptorService } from './core/services/loader-interceptor.service';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { SanitizeInterceptor } from './interceptors/sanitize.interceptor';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgApexchartsModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    ToastrModule.forRoot(
      {
        // timeOut: 10000000000,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
      }
    )

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SanitizeInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "en-US" },
    AuthService,
    AuthGuard,
  ],
  exports: [
    TypeaheadModule,
  ],


  bootstrap: [AppComponent],
})
export class AppModule { }
